import { type FC } from 'react'
import classNames from 'classnames'
import { Button, type IButtonProps } from 'shared/ui'
import styles from './styles.module.scss'

type INextButtonProps = Omit<IButtonProps, 'fullWidth'>

export const NextButton: FC<INextButtonProps> = (props) => {
  return (
    <div className={classNames(styles.wrap, props.className)}>
      <Button fullWidth size='medium' {...props} className={styles.btn} />
    </div>
  )
}
